export default {"src":"/_next/static/media/check.f5d1a61f.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};